import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { marketingI18n } from "../content/homeMarketing";
import useScrollAnimate from "../hooks/useScrollAnimate";
import MarketingPageIntro from "./marketing/MarketingPageIntro";
import PartnerSection from "./marketing/PartnerSection";
import ShopOwnerSection from "./marketing/ShopOwnerSection";
import OnboardingHelpDemo from "./marketing/OnboardingHelpDemo";
import "./MarketingPages.css";
import "./Home.css";

export default function ForBusiness() {
  const { lang } = useLanguage();
  const t = marketingI18n[lang];
  useScrollAnimate([lang]);

  return (
    <div className={`marketing-page ${lang === "ar" ? "rtl" : ""}`} dir={lang === "ar" ? "rtl" : "ltr"}>
      <MarketingPageIntro variant="business" page={t.pages.business} lang={lang} layout="split" />
      <PartnerSection t={t} />
      <ShopOwnerSection t={t} lang={lang} />
      <section className="business-onboarding-demo-section" id="onboarding-help">
        <div className="container">
          <div className="business-onboarding-demo-header scroll-animate from-bottom delay-1">
            <h2>{t.pages.business.highlights[3].title}</h2>
            <p>{t.pages.business.highlights[3].desc}</p>
          </div>
          <div className="business-onboarding-demo-card scroll-animate from-bottom delay-2">
            <OnboardingHelpDemo lang={lang} featured />
          </div>
        </div>
      </section>
      <div className="section-wave section-wave--light" aria-hidden="true" />
    </div>
  );
}
